/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, $Container, ContainerProps, $RichText, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {IHitArea, TextStyle} from 'pixi.js';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';
import {getOrientation} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/utils/getOrientation';
import {ComputedSignal} from '@gongxigames/framework/core';

type StartButtonProps = Omit<ContainerProps, 'scale'> & CanBeSignals<{
    onPress?: () => void;
    hitArea: IHitArea | null;
    scale: number;
}> & {
    showButtonWithText: boolean;
    defaultStyle: Partial<TextStyle>;
};

const {
    maxWidth,
    buttonName,
    localeID,
    hitAreaStartButton,
} = LSViewConfig.startButtonParams;

const $StartButton: FC<StartButtonProps> = (props) => {

    return <$Container {...props}>
        <$Button
            name={buttonName}
            hitArea={props.hitArea}
            action={props.onPress}
        />
        <$RichText localeID={localeID} style={props.defaultStyle} maxWidth={maxWidth} visible={props.showButtonWithText} />

    </$Container>;
};

export const renderStartButton = (
    onStartButtonClicked: Function,
    isStartButtonVisible: ComputedSignal<boolean>) => (
    <$StartButton
        position={getOrientation(LSViewConfig.startButtonParams.position)}
        onPress={() => onStartButtonClicked()}
        hitArea={hitAreaStartButton}
        visible={isStartButtonVisible}
        scale={getOrientation(LSViewConfig.startButtonParams.scale)}
        showButtonWithText={LSViewConfig.startButtonParams.showButtonWithText}
        defaultStyle={LSViewConfig.startButtonParams.defaultStyle}
    />
);